<div id="estimate-form" style="padding: 1rem;" name="div-name">
  <header style="display: flex;">
    <section>
      <img *ngIf="companyLogo" [src]="concatFilePath | memoizedFn:companyLogo?.UriPath:companyLogo?.FileName" alt=""
        class="company-logo" height="90" style="height: 50pt; width: auto;" width="120">
      <div>
        <h1>{{invoice?.Item?.CompanyName}}</h1>
      </div>
      <div class="f-row" *ngIf="invoice?.Item?.LicenseNumber">
        <span style="overflow-wrap: anywhere;">{{ invoice?.Item?.LicenseNumberName | licenseLabel }}</span>
        <span>:</span>
        <span style="padding-left: 4px; overflow-wrap: anywhere;">{{invoice?.Item?.LicenseNumber}}</span>
      </div>
      <div *ngIf="!isEmpty(invoice.Item.CompanyAddress)">
        <div [innerHTML]="invoice.Item.CompanyAddress | addressFormat"></div>
      </div>
      <br>
      <div>
        <div>{{formatNumberForPreivew(invoice?.Item?.CompanyPhoneNo)}}</div>
        <div [innerHTML]="invoice.Item.CompanyEmail | softBreak"></div>
        <div [innerHTML]="invoice.Item.CompanyWebsite | softBreak"></div>
      </div>
    </section>
    <section class="t-right">
      <div>
        <h1 *ngIf="invoice.Item.Status == invoiceStatusEnum.Paid">Receipt</h1>
        <h1 *ngIf="invoice.Item.Status != invoiceStatusEnum.Paid">{{invoice.Item.Title||"Invoice"}}</h1>
      </div>
      <div>
        <strong>
          <span>Invoice Number: </span>
          <span
            style="min-width: 100px; max-width: 100%; display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; vertical-align: bottom;">{{invoice.Item?.InvoiceNumber}}</span>
        </strong>
      </div>
      <div>
        <small>Invoice Date: </small>
        <span class="d-inline-block" id="portal-start-date" style="min-width: 100px; display: inline-block;">
          {{invoice.Item?.InvoiceDate|date:'mediumDate'}}
        </span>
      </div>
      <div>
        <small>Payment Due: </small>
        <span class="d-inline-block" id="portal-start-date" style="min-width: 100px; display: inline-block;">
          {{invoice.Item?.InvoiceDueDate?(invoice.Item?.InvoiceDueDate|date:'mediumDate'):'(set when sent)'}}</span>

      </div>

      <!-- <div>
          <small>Invoice Expires: </small>
          <span class="d-inline-block" id="portal-end-date" style="min-width: 100px; display: inline-block;">
              {{invoice.Item[0]?.EstimateExpiresDate
              |date:'longDate'}}
          </span>
      </div> -->
      <br>

      <!-- customer address here  -->
      <div *ngIf="invoice.Item?.CustomerId">
        <h2>Client</h2>
      </div>

      <div>
        <strong>{{
          (invoice.Item?.CustomerId) ?
          (invoice.Item | displayCompanyAndUserNameEstInvPipe) :
          (
          ((invoice.Item?.CustomerFirstName || invoice.Item?.Customer?.FirstName || '') + ' ' +
          (invoice.Item?.CustomerLastName || invoice.Item?.Customer?.LastName|| '')) + ' '
          + (invoice.Item?.Customer?.CompanyName ? '(' + invoice.Item?.Customer?.CompanyName + ')' : '')
          )
          }}</strong>
      </div>

      <div *ngIf="!isEmpty(invoice.Item.CustomerAddress)">
        <div [innerHTML]="invoice.Item.CustomerAddress | addressFormat:invoice.Item.Customer?.Address"></div>
      </div>
      <div>{{formatNumberForPreivew(invoice.Item?.CustomerPhone || invoice.Item?.Customer?.PhoneNumbers[0]?.PhoneNumber
        || '')}}</div>
      <div [innerHTML]="(invoice.Item?.CustomerEmail || invoice.Item?.Customer?.Emails[0]?.Email || '') | softBreak">
      </div>
      <br>


      <ng-container *ngIf="invoice.Item?.ShowBillingAddressToCustomer && hasPrintableAddress(invoice.Item.CustomerBillingAddress)">
        <div><strong>Billing Address</strong></div>
        <div [innerHTML]="invoice.Item.CustomerBillingAddress|addressFormat">
        </div>
      </ng-container>
      <br>

      <div *ngIf="invoice?.Item?.ShowProjectInfoToCustomer && invoice?.Item?.ProjectId">
        <h2>Project</h2>
        <div>
          <div>
            <strong>{{(invoice?.Item?.ProjectNumber || invoice?.Item?.ProjectV2Entities?.ProjectNumber || '') +
              (((invoice?.Item?.ProjectName || invoice?.Item?.ProjectV2Entities?.Name ||
              invoice?.Item?.ProjectV2Entities?.DisplayName||'').length > 0 && (invoice?.Item?.ProjectNumber ||
              invoice?.Item?.ProjectV2Entities?.ProjectNumber || '').length > 0) ? ' - ' : ' ') +
              (invoice?.Item?.ProjectName || invoice?.Item?.ProjectV2Entities?.Name ||
              invoice?.Item?.ProjectV2Entities?.DisplayName||''|| '')}}</strong>
          </div>
          <div *ngIf="!isEmpty(invoice.Item.ProjectAddress)"
            [innerHTML]="invoice.Item.ProjectAddress | addressFormat:invoice.Item?.ProjectV2Entities?.Address"></div>
          <div *ngIf="invoice?.Item?.ProjectV2Entities?.ProjectPhoneNumbers?.length">
            {{invoice?.Item?.ProjectV2Entities?.ProjectPhoneNumbers[0]?.PhoneNumber || ''}}
          </div>
        </div>
      </div>




    </section>
  </header>

  <ng-template #customerViewInvoice>
    <div class="message">
      <i class="i-file-invoice-dollar big-display"></i>
      <div class="font-22 t-center mb-2">
        <span class="danger">Invoice {{invoice.Item?.InvoiceNumber}} has expired.</span>
      </div>
      <div class="font-22 t-center">Please contact {{ contactCompanyName | memoizedFn: invoice?.Item?.CompanyName : invoice?.Item?.AccountCompanyName }} for assistance.</div>
    </div>
  </ng-template>

  <ng-container
    *ngIf="(invoice.Item?.CustomerCanViewInvoice && invoice.Item?.IsPublished) || (invoice.Item?.IsPublished && invoice.IsPreview); else customerViewInvoice">

    <!-- Introduction -->
    <section>
      <div class="introduction">
        <div class="intro-text description-inner innerHtmlCkEditorContent">
          <p [innerHTML]="invoice?.Item?.Introduction | sanitize"></p>
        </div>
      </div>
    </section>


    <section id="print-vi" class="clear-fix">
      <div class="line-items">
        <table class="line-item-table">
          <tbody class="line-item-table">
            <tr class="table-row header">
              <th class="header-cell">Description</th>
              <th class="header-cell amount-cell">Price</th>
            </tr>

            <!-- <tr *ngFor="let element of invoice.EstimatedLineItems" class="table-row" tabindex=" 1">
                <td class="table-cell line-item">
                    <strong>{{element?.Name || 'Product or Service'}}</strong>
                </td>

                <td class="table-cell line-item amount-cell"><span>{{(element?.InvoicedPrice || 0) | formatNumber}}</span></td>
            </tr> -->

            <ng-container
              *ngIf="!invoice.Item?.IsItemized && invoice.Item.EstimateId && invoice.Item?.EstimateEntity?.EstimateDetails?.length > 0">
              <tr tabindex="1" class="table-row">
                <td class="table-cell line-item">
                  <div> <span class="innerHtmlCkEditorContent"
                      [innerHTML]="(invoice.Item?.Description||'Non-Itemized Invoice')"></span> </div>
                </td>
                <td class="table-cell line-item amount-cell">
                  <span>{{(invoice.Item.Amount) | formatNumber:{
                    symbol: '$',
                    appendSymbolAtStart: true
                    } }}</span>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="invoice.Item?.IsItemized">
              <!-- Estimate Cost Items -->
              <tr class="table-row" tabindex="1" *ngFor="let item of estimateLineItems">
                <ng-container *ngIf="item?.InvoicedPrice">
                  <td class="table-cell line-item">
                    <div class="innerHtmlCkEditorContent" [innerHTML]="item?.Name|sanitize"></div>
                    <span
                      style="opacity: 0.5; margin-bottom: 0.5rem;">{{item.InvoicedPricePercent==100?item.InvoicedPricePercent
                      +'%':(item.InvoicedPricePercent | formatNumber:{
                      symbol: '%',
                      appendSymbolAtStart:false
                      } )}} Invoiced</span>
                  </td>
                  <td class="table-cell line-item amount-cell"><span>{{(item?.InvoicedPrice || 0) |
                      formatNumber}}</span>
                  </td>
                </ng-container>
              </tr>

              <!-- Change Order  -->
              <ng-container *ngIf="estimateChangeOrderLineItems?.length">
                <ng-container *ngFor="let changeOrder of estimateChangeOrderLineItems">
                  <tr class="table-row" style="line-height: 1;" *ngIf="changeOrder.isPrice">
                    <td style="background-color: rgb(255, 255, 255);">
                      <h3 style="opacity: 0.5;"> {{changeOrder.Name}}</h3>
                    </td>
                    <td style="background-color: rgb(255, 255, 255);"></td>
                  </tr>

                  <tr class="table-row" tabindex="1" *ngFor="let item of changeOrder.LineItems" class="">
                    <ng-container *ngIf="item?.InvoicedPrice">
                      <td class="table-cell line-item">
                        <div class="innerHtmlCkEditorContent" [innerHTML]="item?.Name|sanitize"></div>
                        <span style="opacity: 0.5; margin-bottom: 0.5rem;">{{item.InvoicedPricePercent==100?
                          item.InvoicedPricePercent+'%': (item.InvoicedPricePercent | formatNumber:{
                          symbol:'%',
                          appendSymbolAtStart:false
                          }) }} Invoiced</span>
                      </td>

                      <td class="table-cell line-item amount-cell"><span>{{(item?.InvoicedPrice || 0) |
                          formatNumber}}</span>
                      </td>
                    </ng-container>

                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>


            <ng-container *ngIf="invoice.Item?.AdditionalLineItems?.length">
              <tr class="table-row" style="line-height: 1;" *ngIf="invoice.Item.EstimateId">
                <td style="background-color: rgb(255, 255, 255);">
                  <h3 style="opacity: 0.5; margin-top: 10px;">Additional Line Items</h3>
                </td>
                <td style="background-color: rgb(255, 255, 255);"></td>
              </tr>
              <ng-container *ngFor="let item of invoice.Item?.AdditionalLineItems">
                <tr class="table-row total-row description-inner">
                  <td class="table-cell f-100">
                    <div class="">
                      <span class="innerHtmlCkEditorContent" [innerHTML]="((item.Name||'') | sanitize)"></span>
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div>{{((item.Price || 0))|formatNumber}}</div>
                  </td>
                </tr>
                <tr class="table-row total-row">
                  <td colspan="2" style="padding: 0px; border-bottom-color: white;"></td>
                </tr>
              </ng-container>

            </ng-container>


            <!-- <tr class="table-row total-row">
              <td colspan="2" style="padding: 0px; border-bottom-color: white;"></td>
            </tr> -->
            <tr class="table-row">
              <td colspan="4" class="table-cell line-item" style="background: white; height: 24pt;"></td>
            </tr>
            <tr class="table-row total-row">
              <td class="table-cell f-100">
                <div class="t-right"><small class="tax-sub-total">Subtotal</small></div>
              </td>
              <td class="table-cell amount-cell variable">
                <div>{{(invoice.Item?.SubTotal || 0)|formatNumber}}</div>
              </td>
            </tr>
            <tr class="table-row total-row" *ngFor="let dis of invoice.Item?.InvoiceDiscounts | filterDiscounts: true">
              <td class="table-cell f-100">
                <div class="t-right">
                  <strong>{{dis.Name}} ({{dis.Value | formatNumber: {
                    symbol: dis.IsPercentage ? "%" : "$",
                    appendSymbolAtStart: !dis.IsPercentage
                    } }})</strong>
                </div>
              </td>
              <td class="table-cell amount-cell variable">
                <div class="ispostiscounted ">
                  <strong>-{{dis.DiscountedValue | formatNumber}}</strong>
                </div>
              </td>
            </tr>
            <!-- <tr class="table-row total-row">
                <td class="table-cell f-100">
                  <div class="t-right"><small>Discount</small></div>
                </td>
                <td class="table-cell amount-cell variable">
                  <div>{{(invoice.Item?.TotalWithoutTax || 0)|formatNumber}}</div>
                </td>
              </tr> -->
            <tr class="table-row total-row">
              <td class="table-cell f-100">
                <div class="t-right"><span>Tax</span></div>
              </td>
              <td class="table-cell amount-cell variable">
                <div>{{((invoice.Item?.CalculatedTax || 0) + (invoice.Item?.TaxRoundingAdjustment || 0))|formatNumber}}</div>
              </td>
            </tr>

            <tr class="table-row total-row" *ngFor="let dis of invoice.Item?.InvoiceDiscounts | filterDiscounts: false">
              <td class="table-cell f-100">
                <div class="t-right">
                  <strong>{{dis.Name}} ({{dis.Value | formatNumber: {
                    symbol: dis.IsPercentage ? "%" : "$",
                    appendSymbolAtStart: !dis.IsPercentage
                    } }})</strong>
                </div>
              </td>
              <td class="table-cell amount-cell variable">
                <div class="ispostiscounted">
                  <strong>-{{dis.DiscountedValue | formatNumber}}</strong>
                </div>
              </td>
            </tr>

            <ng-container *ngIf="invoice.Item.Payments?.length>0">
              <tr *ngIf="invoice.Item?.TotalDiscount > 0" class="table-row total-row">
                <td class="table-cell f-100">
                  <div class="t-right"><s>Invoice Total</s></div>
                </td>
                <td class="table-cell amount-cell variable">
                  <div [style.font-size]="getTotalFontSize((invoice.Item?.Total || 0) + (invoice.Item?.TotalDiscount || 0))"><s>{{(invoice.Item?.Total || 0) + (invoice.Item?.TotalDiscount || 0) |formatNumber}}</s></div>
                </td>
              </tr>
              <tr class="table-row total-row">
                <td class="table-cell f-100">
                  <div class="t-right"><span>Invoice Total</span></div>
                </td>
                <td class="table-cell amount-cell variable">
                  <div [style.font-size]="getTotalFontSize(invoice.Item?.Total || 0)">{{(invoice.Item?.Total || 0) |formatNumber}}</div>
                </td>
              </tr>
              <tr class="table-row total-row">
                <td class="table-cell f-100">
                  <div class="t-right"><span>Invoice Payments to Date</span></div>
                </td>
                <td class="table-cell amount-cell variable">
                  <div>{{(invoice.Item?.PaymentToDate || 0)|formatNumber}}</div>
                </td>
              </tr>
            </ng-container>

            <tr class="table-row total-row">
              <td class="table-cell f-100">
                <div class="t-right"><strong class="total" style="font-weight: 700 !important;">Amount Due</strong>
                </div>
              </td>
              <td class="table-cell amount-cell variable">
                <div class="total" [style.font-size]="getTotalFontSize(invoice.Item?.RemainingBalance || 0)">
                  <strong>{{(invoice.Item?.RemainingBalance || 0) | formatNumber}}</strong>
                </div>
              </td>
            </tr>
            <ng-container *ngIf="invoice.Item?.Payments.length>0">
              <tr class="table-row total-row">
                <td colspan="2" style="padding: 0px; border-bottom-color: white;"></td>
              </tr>
              <tr class="table-row total-row">
                <td class="table-cell f-100">
                  <div class="t-right"><strong>Payments for this {{invoice.Item.Status == invoiceStatusEnum.Paid ?
                      "receipt" : "invoice"}}</strong></div>
                </td>
                <td class="table-cell amount-cell variable" style="line-height: 1;"><span></span>
                </td>
              </tr>
              <ng-container *ngFor="let pay of invoice.Item?.Payments">
                <tr class="table-row total-row" style="line-height: 1.1;">
                  <td class="table-cell f-100" style="padding-bottom: 0px; padding-top: 0px;">
                    <div class="t-right f-column"><span>{{getPaymentTypeString(pay.Type)}} Payment
                        ({{pay.DateTime | date :'MMM d, y'}})</span><small class="fade"><em>Payment
                          {{getPaymentStatusType(pay.Status)}}</em></small></div>
                  </td>
                  <td class="table-cell amount-cell variable" style="padding-bottom: 0px; padding-top: 0px;">
                    <div><span class="">{{pay.Amount | formatNumber}}</span></div>
                  </td>
                </tr>
                <ng-container *ngIf="pay.Status === PaymentStatusTypes.Completed && !pay.ClientPaysFees && pay.FeeAmount > 0">
                  <tr class="table-row total-row" style="line-height: 1.1;">
                    <td class="table-cell f-100" style="padding-bottom: 0px; padding-top: 0px;">
                      <div class="t-right"><span>Processing fee</span></div>
                    </td>
                    <td class="table-cell amount-cell variable" style="padding-bottom: 0px; padding-top: 0px;">
                      <div><span class="">{{pay.FeeAmount | formatNumber}}</span></div>
                    </td>
                  </tr>
                  <tr class="table-row total-row" style="line-height: 1.1;">
                    <td class="table-cell f-100" style="padding-bottom: 0px; padding-top: 0px;">
                      <div class="t-right"><strong>Total charged</strong></div>
                    </td>
                    <td class="table-cell amount-cell variable" style="padding-bottom: 0px; padding-top: 0px;">
                      <div><strong>{{(pay.Amount + pay.FeeAmount) | formatNumber}}</strong></div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              <!-- <tr class="table-row">
                <td colspan="4" class="table-cell line-item" style="background: white; height: 24pt;"></td>
              </tr> -->
            </ng-container>

            <!-- <ng-container *ngIf="invoice.Item.EstimateId && invoice?.settings?.DisplayPaymentProgress">
            <tbody [popover]="projectFinancialsTooltip" 
              placement="right" 
              container="body"
              triggers="mouseenter:mouseleave"
              [adaptivePosition]="true">
            <tr class="table-row total-row" >
                <td class="table-cell f-100" style="padding-top: 10pt; padding-bottom: 0px; background: white;  border: 0">
                    <div>
                        <strong style="color: rgb(101, 101, 101);">Project Financials {{(invoice.Item?.InvoiceDate ? (('as of ') +  (invoice.Item?.InvoiceDate | date: "mediumDate") ) : '')}}</strong>
                    </div>
                </td>
                <td class="table-cell amount-cell variable"
                    style="padding-top: 10pt; padding-bottom: 0px; line-height: 1; background: white;  border: 0"></td>
            </tr>

            <tr class="table-row total-row">
                <td class="table-cell f-100" style="padding-bottom: 0px; background: white;  border: 0">
                    <div>
                        <span style="color: rgb(101, 101, 101);">Project Total: </span>
                        <span style="color: rgb(101, 101, 101);">
                          <span class="font-roboto">{{(invoice.Item.TotalEstimated || 0) | formatNumber}}</span>
                        </span>
                    </div>
                </td>
                <td class="table-cell amount-cell variable" style="padding-bottom: 0px; background: white;  border: 0"></td>
            </tr>

            <tr *ngIf="invoice?.Item.ProjectDiscounts > 0" class="table-row total-row">
                <td class="table-cell f-100" style="padding-top: 0px; padding-bottom: 0px; background: white;  border: 0">
                  <div style="color: #48a759">
                    <span>Project Discounts: </span>
                    <span class="font-roboto">
                      <span><i>-{{(invoice?.Item.ProjectDiscounts || 0) | formatNumber}}</i></span>
                      <span *ngIf="invoice?.Item.TaxableGapDueToDiscount > 0"><i> (-{{(invoice?.Item.TaxableGapDueToDiscount || 0) | formatNumber}} tax)</i></span>
                    </span>
                </div>
                </td>
                <td class="table-cell amount-cell variable" style="padding-top: 0px; padding-bottom: 0px; background: white;  border: 0"></td>
            </tr>

            <tr class="table-row total-row ">
                <td class="table-cell f-100" style="padding-top: 0px; padding-bottom: 0px; background: white;  border: 0">
                    <div><span style="color: rgb(101, 101, 101);">Invoiced Total:
                        </span><span style="color: rgb(101, 101, 101);">
                          <span class="font-roboto">
                            {{(invoice.Item.OtherInvoicesTotal) | formatNumber:{
                              symbol:'$',
                              appendSymbolAtStart: true
                            } }}</span>
                        </span>
                    </div>
                </td>
                <td class="table-cell amount-cell variable"
                    style="padding-top: 0px; padding-bottom: 0px; background: white;  border: 0"></td>
            </tr>
            <tr class="table-row total-row ">
                <td class="table-cell f-100" style="padding-top: 0px; background: white;  border: 0">
                    <div><span style="color: rgb(101, 101, 101);">Remaining Amount to Invoice:
                        </span><span style="color: rgb(101, 101, 101);"><span class="font-roboto">{{invoice.Item.EstimateProjectBalance|formatNumber}}</span></span>
                    </div>
                </td>
                <td class="table-cell amount-cell variable" style="padding-top: 0px; background: white;  border: 0"></td>
            </tr>
            </tbody>
            </ng-container> -->

          </tbody>
        </table>

        <div class="project-financials-main-wrapper"
          *ngIf="invoice.Item.EstimateId && invoice?.settings?.DisplayPaymentProgress && invoice.Item.EstimateEntity?.EstimateDetails?.[0]?.Status !== estimateStatusTypes.Closed">
          <div class="pf-wrapper-inner" style="display: inline-block;">
            <div>
              <strong style="color: rgb(101, 101, 101);">Project Financials {{(invoice.Item?.InvoiceDate ? (('as of ') +
                (invoice.Item?.InvoiceDate | date: "mediumDate") ) : '')}}</strong>
            </div>
            <div>
              <span style="color: rgb(101, 101, 101);">Project Total: </span>
              <span style="color: rgb(101, 101, 101);">
                <span class="font-roboto">{{(invoice.Item.TotalEstimated || 0) | formatNumber}}</span>
              </span>
            </div>
            <div *ngIf="invoice?.Item.ProjectDiscounts > 0" style="color: #48a759">
              <span>Project Discounts: </span>
              <span class="font-roboto">
                <span><i>-{{(invoice?.Item.ProjectDiscounts || 0) | formatNumber}}</i></span>
                <span *ngIf="invoice?.Item.TaxableGapDueToDiscount > 0"><i> (-{{(invoice?.Item.TaxableGapDueToDiscount
                    || 0) | formatNumber}} tax)</i></span>
              </span>
            </div>
            <div>
              <span style="color: rgb(101, 101, 101);">Invoiced Total:</span>
              <span style="color: rgb(101, 101, 101);">
                <span class="font-roboto">
                  {{(invoice.Item.OtherInvoicesTotal) | formatNumber:{
                  symbol:'$',
                  appendSymbolAtStart: true
                  } }}
                </span>
              </span>
            </div>
            <div>
              <span style="color: rgb(101, 101, 101);">Remaining Amount to Invoice:</span>
              <span style="color: rgb(101, 101, 101);">
                <span class="font-roboto"> {{invoice.Item.EstimateProjectBalance|formatNumber}}</span>
              </span>
            </div>
          </div>
          <!-- Project Financials Tooltip Template -->
          <div class="project-financials-tooltip-content">
            <div>
              <div class="pf-tt-item">
                <strong>Project Total</strong>
                <span>The total published value of the project</span>
              </div>
              <div class="pf-tt-item">
                <strong>Project Discounts</strong>
                <span>All of the published discounts for the project</span>
              </div>
              <div class="pf-tt-item">
                <strong>Invoiced Total</strong>
                <span>All of the published invoices for the project</span>
              </div>
              <div class="pf-tt-item">
                <strong>Remaining Amount to Invoice</strong>
                <span>The remaining value of the project to be invoiced. (Project Total – Discounts – Invoiced
                  Total)</span>
              </div>
            </div>
          </div>

        </div>


        <!-- Project Financials Popover Template -->
        <!-- <ng-template #projectFinancialsTooltip>
  <div class="project-financials-popover-content" style="min-width: 350px; background: #2c2c2c; color: #fff; padding: 12px; border-radius: 6px;">
    <div>
      <div style="display: flex; align-items: flex-start; margin-bottom: 12px;">
        <strong style="color: #fff; min-width: 180px; font-size: 13px;">Project Total</strong>
        <span style="color: #b0b0b0; font-size: 12px; line-height: 1.4;">The total published value of the project</span>
      </div>
      <div style="display: flex; align-items: flex-start; margin-bottom: 12px;">
        <strong style="color: #fff; min-width: 180px; font-size: 13px;">Project Discounts</strong>
        <span style="color: #b0b0b0; font-size: 12px; line-height: 1.4;">All of the published discounts for the project</span>
      </div>
      <div style="display: flex; align-items: flex-start; margin-bottom: 12px;">
        <strong style="color: #fff; min-width: 180px; font-size: 13px;">Invoiced Total</strong>
        <span style="color: #b0b0b0; font-size: 12px; line-height: 1.4;">All of the published invoices for the project</span>
      </div>
      <div style="display: flex; align-items: flex-start;">
        <strong style="color: #fff; min-width: 180px; font-size: 13px;">Remaining Amount to Invoice</strong>
        <span style="color: #b0b0b0; font-size: 12px; line-height: 1.4;">The remaining value of the project to be invoiced. (Project Total – Discounts – Invoiced Total)</span>
      </div>
    </div>
  </div>
</ng-template> -->
      </div>
    </section>




    <!-- Contact Details -->
    <!-- Introduction -->
    <section *ngIf="invoice?.Item?.ContactDetails">
      <div class="introduction">
        <div class="intro-text description-inner innerHtmlCkEditorContent">
          <p [innerHTML]="invoice?.Item?.ContactDetails | sanitize"></p>
        </div>
      </div>
    </section>

    <!-- Files and Photos -->
    <section class="no-print clear-fix" *ngIf="filesList.length || photosList.length">
      <h5 *ngIf="filesList.length" style="color: gray;">Files</h5>
      <div class="estimate-gallery">
        <div class="gallery-holder">
          <div class=" gallery" style="min-height: 70px;">
            <div>
              <div class="file-list">
                <a *ngFor="let item of filesList"
                  [href]="item?.UriPath+ ( $any(item?.FileNameURI)|| $any(item?.FileName))" class="file-item"
                  rel="noopener noreferrer" target="_blank">
                  <div class="file-block">
                    <div class="focus-block back-"><i class="i-file"></i></div>
                    <div class="content">
                      <strong>{{item?.DisplayName}}</strong><small>{{item?.FileName}}</small><small></small>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h5 *ngIf="photosList.length" class="hide-print" style="color: gray;">Photos</h5>
      <div class=" estimate-gallery hide-print">
        <div class="gallery-holder" id="projul-gallery">
          <div class="gallery" style="min-height: 90px;">
            <div class="card-wrapper">
              <div *ngFor="let item of photosList" class="card-item">
                <div class="card-image"><img [src]="photoThumbUrl | memoizedFn : item : $any(item)?._thumbFailed" (error)="onThumbError(item)" loading="lazy" alt=""
                    (click)="openImageInFullScreen(item,photosList)" height="90" width="120">
                </div>
                <div class="card-name mt-2"><span title="download.png">{{item?.DisplayName}}</span>
                </div>
                <div class="card-date"> {{ item?.DateUploaded | date: "medium" }}</div>
                <div class="card-desc"></div>
              </div>

            </div>
            <div></div>
          </div>
        </div>
      </div>

    </section>
    <div class="show-print d-none">
      <div class="non-itemized-images-print ">
        <ng-container *ngFor="let item of photosList">
          <div class="image-items d-flex align-items-center Medium">
            <img [src]="photoThumbUrl | memoizedFn : item : $any(item)?._thumbFailed" (error)="onThumbError(item)" loading="lazy" alt="">
          </div>
        </ng-container>
      </div>
    </div>

    <div class="hide-print mob-hide">

      <!-- Print Button Section -->

      <section style="margin-top: 2rem;">
        <div class="f-row f-center">
          <button (click)="handlePrintPDF()" class="round no-border">
            <i class="i-print"></i>
            <span>Print {{invoice.Item.Status == invoiceStatusEnum.Paid ? "receipt" : "invoice"}}
              {{invoice.Item?.EstimateNumber}}</span>
          </button>
        </div>

      </section>

    </div>

  </ng-container>
</div>